import {ThemeColors} from '../themeColors';

export const useSpotTextColors = () => ThemeColors.spotText;
